import { useState } from "react";

import type { Note as NoteType } from "common/types";

import DeleteNoteDialog from "./DeleteNoteDialog";
import Note from "./Note";

interface LeadNotesListProps {
  notes: NoteType[];
  profileId: string;
}

export default function LeadNotesList({
  notes,
  profileId,
}: LeadNotesListProps) {
  const [deleteNoteId, setDeleteNoteId] = useState(null);

  return (
    <>
      {!!notes.length && (
        <div className="flex flex-col gap-y-2">
          {notes.map((note) => (
            <Note
              key={note.id}
              profileId={profileId}
              note={note}
              onDelete={() => setDeleteNoteId(note.id)}
            />
          ))}
        </div>
      )}
      <DeleteNoteDialog
        profileId={profileId}
        noteId={deleteNoteId}
        onClose={() => setDeleteNoteId(null)}
      />
    </>
  );
}
